import { StyleProps, callCSSFn, CSSFn, CSS } from "@shared/primitive-components"

type RootStyleProps = StyleProps & { css?: CSSFn }
export const getRootStyle =
  (css?: CSSFn) =>
  (props: RootStyleProps): CSS => ({
    width: `100%`,
    flexDirection: `column`,
    marginBottom: props.theme.spacing(4),
    ...callCSSFn({ ...props, css }),
  })

export const titleWrap = (props: StyleProps) => ({
  padding: props.theme.spacing(4),
  backgroundColor: props.theme.palette.brand,
  margin: props.theme.spacing(-6, -6, 0, -6),
})
